
define('text!modules/filter/filter_template.html',[],function () { return '    <div class="create-filter">\r\n      <div class="js-filter-infotext--toptext"></div>\r\n      <div id="filter"></div>\r\n      <div class="js-filter-picker"></div>\r\n      <div class="js-filter-infotext--bottomtext"></div>\r\n    </div>\r\n\r\n';});

